import { createReducer, on } from '@ngrx/store';

import { AppleDeviceProfileApiActions } from './apple-device-profile.actions';
import { adapter, initialState } from './apple-device-profile.state';

export const APPLE_DEVICE_PROFILE_FEATURE_KEY = 'apple-device-profiles';

export const appleDeviceProfileReducer = createReducer(
  initialState,
  // When profile entries are loaded, replace all existing entries for the same
  // udid/profileType combination. This ensures deletions on the server are reflected
  // in the client store. Empty arrays are treated as valid replacements (clearing all).
  on(AppleDeviceProfileApiActions.profileLoaded, (state, { entries }) => {
    if (!entries || entries.length === 0) {
      return state;
    }

    // Get udid/profileType from first entry (effects load one profileType per request)
    const { udid, profileType } = entries[0];
    const prefix = `${udid}-${profileType}`;

    // Remove all existing entries for this udid/profileType combination
    const idsToRemove = (state.ids as string[]).filter((id) => id.startsWith(prefix));
    const stateWithoutOld = adapter.removeMany(idsToRemove, state);

    // Add all new entries
    return adapter.addMany(entries, stateWithoutOld);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAppleDeviceProfileIds = selectIds;

export const selectAppleDeviceProfileEntities = selectEntities;

export const selectAppleDeviceProfiles = selectAll;
